import { CuiDateOrTimeTodayPipe } from './date-or-time-today.pipe';
import { NgModule } from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import { MatCardModule } from '@angular/material';

@NgModule({
  declarations: [
    CuiDateOrTimeTodayPipe
  ],
  exports: [
    CuiDateOrTimeTodayPipe
  ],
  providers: [
    DatePipe
  ]
})
export class CuiPipesModule {}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/pipes/pipes.module.ts